export default __webpack_public_path__ + "static/media/advocates_light_logo.18c277ae.svg";